import { isDashboardFrame } from 'adapter/in/common/widget/widgetBuilder';
import ReadWidgetDataClient from 'use-case/widgets/data/read/readWidgetDataClient';
import ReadWidgetDataCriteria from 'use-case/widgets/data/read/readWidgetDataCriteria';

const isFrame = (criteria: ReadWidgetDataCriteria) => isDashboardFrame(criteria.widgetId);

const isTextBlock = (criteria: ReadWidgetDataCriteria) => criteria.destination === 'texts';

const readWidgetDataRouterClient = (
    frameClient: ReadWidgetDataClient,
    textBlockClient: ReadWidgetDataClient,
    defaultClient: ReadWidgetDataClient
): ReadWidgetDataClient => (criteria: ReadWidgetDataCriteria) => {
    if (isFrame(criteria)) {
        return frameClient(criteria);
    }

    if (isTextBlock(criteria)) {
        return textBlockClient(criteria);
    }

    return defaultClient(criteria);
};

export default readWidgetDataRouterClient;
